import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { PurchaseOrderRequest } from "../models/purchase-order.model";
import { DatePipe } from '@angular/common';
@Injectable({
    providedIn: 'root'
})
export class PurchaseOrderService {

    private url = environment.api + "api/erp/purchase/orders";
    constructor(
        private http: HttpClient,
        private datePipe: DatePipe
    ) { }

    addOrder(newOrder: PurchaseOrderRequest) {
        return this.http.post(this.url, newOrder);
    }

    getOrders(){
        return this.http.get(this.url+"/active");
    }

    getOrdersAssociated(){
        return this.http.get(this.url+"/active-associated");
    }

    getOrdersNotAssociated(){
        return this.http.get(this.url+"/active-not-associated");
    }

    getOrder(orderId: number) {
        return this.http.get(this.url+`/detail/${orderId}`);
    }

    getOrdersActive() {
		return this.http.get(this.url + "/active");
	}

    getOrdersActiveAndType(statusType: number) {
		return this.http.get(this.url + "/active/type/"+statusType);
	}

    getOrdersInactive() {
		return this.http.get(this.url + "/inactive");
	}

    putOrderDeliverDate(orderId: number, deliveryDate: Date) {
        const formattedDate = deliveryDate.toLocaleDateString('en-CA');
        // crea el Date a partir de la fecha formateada
        const baseDate = new Date(formattedDate);
        // suma 6 horas en milisegundos
        const timestamp = baseDate.getTime() + (6 * 60 * 60 * 1000);

		return this.http.put(this.url + `/${orderId}/${timestamp}`, {});
	}

    putOrderDetailCostToRecive(orderId: number, productId: number, cost: number, toReceive: number) {
        // cost = parseFloat(cost.toFixed(4));
        // toReceive = parseFloat(toReceive.toFixed(4));
        return this.http.put(this.url + `/${orderId}/${productId}/${cost}/${toReceive}`, {});
    }

    putOrderDetailCostQuantity(orderId: number, productId: number, data: any) {
        return this.http.put(this.url + `/${orderId}/${productId}/costs/quantities`, data);
    }

    putOrderDetailCostToReceive(orderId: number, productId: number, data: any) {
        return this.http.put(this.url + `/${orderId}/${productId}/costs/to-receives`, data);
    }

    putStateActiveOrder(orderId: number) {
        return this.http.put(this.url + `/${orderId}/state-active`, {});
    }

    putEditDetailFromInvoice(data: any, orderId: number, purchaseOrderDetailId: number) {
        return this.http.put(this.url + `/${orderId}/details/${purchaseOrderDetailId}`, data);
    }

    putEditDetailWarehouse(detailId: number, warehouseId: number) {
        return this.http.put(this.url + `/details/${detailId}/warehouses/${warehouseId}`, {});
    }

    getReportCalendarForDays(startDate: Date, endDate: Date){
        const formattedDateStart = startDate.toLocaleDateString('en-CA');
        const baseDateStart = new Date(formattedDateStart);
        const timestampStart = baseDateStart.getTime() + (6 * 60 * 60 * 1000);

        const formattedDateEnd = endDate.toLocaleDateString('en-CA');
        const baseDateEnd = new Date(formattedDateEnd);
        const timestampEnd = baseDateEnd.getTime() + (6 * 60 * 60 * 1000);

        return this.http.get(this.url + `/report/days/${timestampStart}/${timestampEnd}`);
    }

    getReportCalendarForWeek(startDate: Date, endDate: Date){
        const formattedDateStart = startDate.toLocaleDateString('en-CA');
        const baseDateStart = new Date(formattedDateStart);
        const timestampStart = baseDateStart.getTime() + (6 * 60 * 60 * 1000);

        const formattedDateEnd = endDate.toLocaleDateString('en-CA');
        const baseDateEnd = new Date(formattedDateEnd);
        const timestampEnd = baseDateEnd.getTime() + (6 * 60 * 60 * 1000);

        return this.http.get(this.url + `/report/weeks/${timestampStart}/${timestampEnd}`);
    }

    getReportPurchaseOrderFromWeeks(productId: number,startDate: Date, endDate: Date){
        return this.http.get(this.url + `/report/active/${productId}/${startDate}/${endDate}`);
    }

    updateCurrency(orderId: number, currencyType: number){
        return this.http.put(this.url + `/${orderId}/currency/${currencyType}`, {});
    }
    
}
